module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "fixed top-0 left-0 bottom-0 right-0 z-9999 overflow-hidden w-100 h-100 bg-black-40 fade overflow-y-scroll",
    attrs: {
      "id": "overlay",
      "role": "dialog",
      "tabindex": "-1"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "ma2 mv4 bg-white mt5-ns mb6-ns ba b--light-gray br2 center-ns animated-slow slide-in",
    class: (_vm.small) ? 'mw6' : 'mw7',
    attrs: {
      "id": "modal"
    }
  }, [_c('div', {
    staticClass: "pa3"
  }, [_vm._t("modal-body", function() {
    return [_vm._v("Placeholder modal body")]
  })], 2)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1e42112c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e42112c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalWithOnlyBody.vue
// module id = 1471
// module chunks = 0